module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch01"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5"
    }
  }, [_vm._v("OBSERVING & DRAWING ANIMALS")])]), _vm._v(" "), _c('div', {
    staticClass: "land100"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4"
    }
  }, [_c('a', {
    attrs: {
      "id": "f0004-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "f0004-01"
    }
  }), _c('div', {
    staticClass: "land40"
  }, [_c('a', {
    attrs: {
      "id": "f0004-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0005-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0005-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0005-01"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOLS")]), _vm._v(" & M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATERIALS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("D")]), _vm._v("rawing is not only fun, it also is an important art form in itself. Even when you write or print your name, you are actually drawing! If you organize the lines, you can make shapes; and when you carry that a bit further and add dark and light shading, your drawings begin to take on a three-dimensional form and look more realistic. One of the great things about drawing is that you can do it anywhere, and the materials are very inexpensive. You do get what you pay for, though, so purchase the best you can afford at the time, and upgrade your supplies whenever possible. Although anything that will make a mark can be used for some type of drawing, you’ll want to make certain your magnificent efforts will last and not fade over time. Here are some materials that will get you off to a good start.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0005-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0005-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0006-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0006-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Work Station")]), _vm._v(" It is a good idea to set up a work area that has good lighting and enough room for you to work and lay out your tools. Of course, an entire room with track lighting, easel, and drawing table is ideal. But all you really need is a place by a window for natural lighting. When drawing at night, you can use a soft white light bulb and a cool white fluorescent light so that you have both warm (yellowish) and cool (bluish) light.")])])]), _c('a', {
    attrs: {
      "id": "f0006-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0006-03"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0006-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0006-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0006-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Sketch Pads")]), _vm._v(" Conveniently bound drawing pads come in a wide variety of sizes, textures, weights, and bindings. They are particularly handy for making quick sketches and when drawing outdoors. You can use a large sketchbook in the studio for laying out a painting, or take a small one with you for recording quick impressions when you travel. Smooth- to medium-grain paper texture (which is called the “tooth”) often is an ideal choice.")])])]), _c('a', {
    attrs: {
      "id": "f0006-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0006-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0006-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0006-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0006-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Charcoal Papers")]), _vm._v(" Charcoal paper and tablets also are available in a variety of textures. Some of the surface finishes are quite pronounced, and you can use them to enhance the texture in your drawings. These papers also come in a variety of colors, which can add depth and visual interest to your drawings.")])])]), _c('a', {
    attrs: {
      "id": "f0006-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0006-02"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0006-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0006-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0006-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Drawing Papers")]), _vm._v(" For finished works of art, using single sheets of drawing paper is best. They are available in a range of surface textures: smooth grain (plate and hot pressed), medium grain (cold pressed), and rough to very rough. The cold-pressed surface is the most versatile. It is of medium texture but it’s not totally smooth, so it makes a good surface for a variety of different drawing techniques.")])])]), _c('a', {
    attrs: {
      "id": "f0006-04"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev2"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHERING THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASICS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("O")]), _vm._v("ne of the nicest things about drawing with pencil, charcoal or black wash is the fact that the materials are simple and very portable so they can be taken with you in the field. They are not terribly expensive either! As you experiment with various drawing techniques, you will find what works best for you. The following tools and materials are what work for me. Feel free to experiment with other tools, papers and techniques. There is always more than one way to draw.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0006-04"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0006-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0007-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0007-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Brush")]), _vm._v(" This inexpensive brush (A) works well to brush away eraser crumbs and other debris from the surface of the paper.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Stick Eraser")]), _vm._v(" A refillable stick eraser (B) is useful for getting into tight places. You may want to use it in conjunction with the erasing shield.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Pencil Extender")]), _vm._v(" Get the most out of your pencils! Use a pencil extender (C) to lengthen short pencils.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Blending Tools")]), _vm._v(" Tortillons (D), sometimes called blending stumps, are used for blending shades of graphite or charcoal and for softening edges. When the tip gets dirty, you can clean it by rubbing it on a kneaded eraser.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Kneaded Eraser")]), _vm._v(" A kneaded eraser (E) is a very useful tool. It can be shaped to get into tight places or can be flattened to lift graphite or charcoal from the paper, and it won’t damage the surface of the paper. It also doesn’t leave annoying crumbs.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Erasing Shield")]), _vm._v(" Use this shield (F) for protecting areas that you do not want to erase.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("White Plastic Eraser")]), _vm._v(" Useful for erasing larger surface areas, this eraser (G) does a nice job of lifting out darker values. Use it with care so you don’t damage the paper.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Sharpeners")]), _vm._v(" A hand-held sharpener (H) will give your pencils sharp tips. You can use the fine point for thin lines and details, and you can use the side for shading with broad strokes. A sandpaper block (I) gives you more control over the shape of the point. Gently roll the pencil tip over the block for a round, even point—or flatten the lead into a blunt, squared tip.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Pencils")]), _vm._v(" Pencils come in a vast array of options. You can try different kinds to find those that work best for your drawing style. Some of the types available are wood-cased (J), woodless (K), and mechanical (L). Pencils also come in varying degrees of hardness. H pencils are hard and are best for light sketches, and B pencils are softer and suitable for shading different areas of your subject. The higher the number preceding the letter, the harder or softer the pencil will be. For example, a 4H pencil is very hard and produces a light shade of graphite, whereas a 9B is very soft and yields a dark, rich mark. Note that hard pencils can dent your paper, so use them with a light hand. I typically start my initial drawing with an HB pencil, which is equivalent to a standard #2 pencil. The pencils I use most often are HB, 3B, 4B, 6B, and 9B. I can achieve a wide range of values using these pencils. Anything over a 6B should be reserved for the darkest areas of the image.")])])]), _c('a', {
    attrs: {
      "id": "f0007-01"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev3"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DDITIONAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UPPLIES")])])])]), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0007-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0008-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0008-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Watercolor")]), _vm._v(" You may want to add simple watercolor washes (thin layers of paint) to your drawings to give them some extra pizzazz. For this, you’ll just need a few paintbrushes (I prefer sable brushes), a tube of black watercolor paint, and a palette for mixing different values. You should also have paper towels handy for wiping excess water off the brush. You may want to try out some painting techniques on scrap paper before applying washes to your drawing.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0008-01"
    }
  }), _c('div', {
    staticClass: "portvh60"
  }, [_c('a', {
    attrs: {
      "id": "f0008-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0008-03"
    }
  }, [_c('img', {
    staticClass: "vh60",
    attrs: {
      "alt": "Image",
      "src": "images/f0008-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0008-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Charcoal")]), _vm._v(" Like pencils, charcoal is available in several forms. Charcoal pencils also come in varying degrees of hardness, but not as many as graphite pencils. You can also buy raw charcoal sticks. Some artists even use burnt wood scraps from their own fireplace. When blending charcoal, use the same tools you use to blend graphite.")])])]), _c('a', {
    attrs: {
      "id": "f0008-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0008-03"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0008-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0008-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0008-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0008-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Light Table")]), _vm._v(" A light table is useful for transferring your preliminary drawing to a clean sheet of paper. You can also use it to refine your initial sketches by tracing your image onto another sheet of paper.")])])]), _c('a', {
    attrs: {
      "id": "f0008-02"
    }
  }), _c('aside', {
    staticClass: "sidebara",
    attrs: {
      "epub:type": "sidebar"
    }
  }, [_c('a', {
    attrs: {
      "id": "f0008-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0008-02"
    }
  }, [_c('p', {
    staticClass: "stitle"
  }, [_c('strong', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLDING")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAWING")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENCIL")])])])]), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0008-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0008-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0008-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0008-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Basic Underhand")]), _vm._v(" The basic underhand position allows your arm and wrist to move freely, which results in fresh and lively sketches. Drawing in this position makes it easy to use both the point and the side of the lead by simply changing your hand and arm angle.")])])]), _c('a', {
    attrs: {
      "id": "f0008-04"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0008-04"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0008-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0008-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0008-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0008-05"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Underhand Variation")]), _vm._v(" Holding the pencil at its end lets you make very light strokes, both long and short. It also gives you a delicate control of lights, darks, and textures. Place a protective “slip sheet” under your hand when you use this position so you don’t smudge your drawing.")])])]), _c('a', {
    attrs: {
      "id": "f0008-05"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0008-05"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0008-05"
    }
  }), _c('a', {
    attrs: {
      "id": "f0008-06"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0008-06.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0008-06"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('strong', [_vm._v("Writing")]), _vm._v(" The writing position is the most common one, and it gives you the most control for fine detail and precise lines. Be careful not to press too hard on the point, or you’ll make indentations in the paper. Also remember not to grip the pencil too tightly, as your hand may get cramped.")])])]), _c('a', {
    attrs: {
      "id": "f0008-06"
    }
  })]), _c('a', {
    attrs: {
      "id": "f0008-06"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev4"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THER")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYS TO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HADE")])])]), _vm._v(" "), _c('h5', {
    staticClass: "h5"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACTICING")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When drawing lines, it is not necessary to always use a sharp point. In fact, sometimes a blunt point may create a more desirable effect. When using larger lead diameters, the effect of a blunt point is even more evident. Play around with your pencils to familiarize yourself with the different types of lines they can create. Make every kind of stroke you can think of, using both a sharp point and a blunt point. Practice the strokes below to help you loosen up.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("As you experiment, you will find that some of your doodles will bring to mind certain imagery or textures. For example, little Vs can be reminiscent of birds flying, whereas wavy lines can indicate water.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAWING WITH A")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARP")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OINT")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("First draw a series of parallel lines. Try them vertically; then angle them. Make some of them curved, trying both short and long strokes. Then try some wavy lines at an angle and some with short, vertical strokes. Try making a spiral and then grouping short, curved lines together. Then practice varying the weight of the line as you draw. Os, Vs, and Us are some of the most common alphabet shapes used in drawing.")])])]), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0008-06"
    }
  }), _c('a', {
    attrs: {
      "id": "f0009-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0009-01"
    }
  }), _c('aside', {
    staticClass: "sidebar",
    attrs: {
      "epub:type": "sidebar"
    }
  }, [_c('a', {
    attrs: {
      "id": "f0009-01"
    }
  }, [_c('p', {
    staticClass: "stitle2"
  }, [_c('strong', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAWING WITH A")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LUNT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OINT")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now try the same exercise with a blunt point. Even if you use the same hand positions and strokes, the results will be different when you switch pencils. Take a look at these examples. The same shapes were drawn with both pencils, but the blunt pencil produced different images. You can create a blunt point by rubbing the tip of the pencil on a sandpaper block or on a rough piece of paper.")])]), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0009-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0009-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0009-02"
    }
  })]), _c('a', {
    attrs: {
      "id": "f0009-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0009-02"
    }
  }, [_c('h5', {
    staticClass: "h5"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10"
    }
  }, [_c('strong', [_vm._v("“P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINTING")]), _vm._v("” "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WITH")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENCIL")])])])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "f0009-02"
    }
  }, [_vm._v("When you use painterly strokes, your drawing will take on a new dimension. Think of your pencil as a brush and allow yourself to put more of your arm into the stroke. To create this effect, try using the underhand position, holding your pencil between your thumb and forefinger and using the side of the pencil. (See ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/ch01#page_8"
    }
  }, [_vm._v("here")]), _vm._v(".) If you rotate the pencil in your hand every few strokes, you will not have to sharpen it as frequently. The larger the lead, the wider the stroke will be. The softer the lead, the more painterly an effect you will have. These examples were all made on smooth paper with a 6B pencil, but you can experiment with rough papers for more broken effects.")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0010-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0010-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Starting Simply")]), _vm._v(" First experiment with vertical, horizontal, and curved strokes. Keep the strokes close together and begin with heavy pressure. Then lighten the pressure with each stroke.")])])]), _c('a', {
    attrs: {
      "id": "f0010-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0010-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0010-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0010-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0010-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Varying the Pressure")]), _vm._v(" Randomly cover the area with tone, varying the pressure at different points. Continue to keep your strokes loose.")])])]), _c('a', {
    attrs: {
      "id": "f0010-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0010-03"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0010-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0010-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0010-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Using Smaller Strokes")]), _vm._v(" Make small circles for the first example. This is reminiscent of leathery animal skin. For the second example, use short, alternating strokes of heavy and light pressure to create a pattern that is similar to stone or brick.")])])]), _c('a', {
    attrs: {
      "id": "f0010-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0010-02"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0010-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0010-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0010-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Loosening Up")]), _vm._v(" Use long vertical strokes, varying the pressure for each stroke until you start to see long grass (above). Then use somewhat looser movements that could be used for water. First create short spiral movements with your arm (top right). Then use a wavy movement, varying the pressure (bottom right).")])])]), _c('a', {
    attrs: {
      "id": "f0010-04"
    }
  }), _c('aside', {
    staticClass: "sidebara",
    attrs: {
      "epub:type": "sidebar"
    }
  }, [_c('a', {
    attrs: {
      "id": "f0010-04"
    }
  }, [_c('p', {
    staticClass: "stitle1"
  }, [_c('strong', [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XERCISE")])])]), _vm._v(" "), _c('p', {
    staticClass: "stitle2"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RY")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFFERENT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENCILS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Make a scribble-art design and fill it in using different grades of pencil. Making these marks side by side will help you become familiar with the different pencil grades, as well as the pressure you need to apply to create a specific value, which is the relative lightness or darkness of the graphite.")])]), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0010-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0010-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0010-05"
    }
  })]), _c('a', {
    attrs: {
      "id": "f0010-05"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev5"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENCIL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INES")]), _vm._v(" & T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXTURES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("f you’re a beginner, focus on learning the drawing process rather than completing the final product for now. Hold your pencil or charcoal with a relaxed grip so the lines flow easily, keeping your approach simple and direct. First make note of the overall shape of the subject, and sketch a few light guidelines from your observations. Once those are correct, make a preliminary drawing, concentrating on basic line angles, shapes, and masses.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Remember that a sure pencil line doesn’t just come from talent; it comes from practice. Study the various textures and strokes shown on this page, and do some practice exercises. For example, give the fish some scales, add bricks to the stone wall, or draw foliage on the trees.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0010-05"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0010-05"
    }
  }), _c('a', {
    attrs: {
      "id": "f0011-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0011-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Notice the type of line each pencil point produces.")])])])]), _c('a', {
    attrs: {
      "id": "f0011-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0011-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0011-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0011-02"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev6"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12"
    }
  }, [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDERSTANDING")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("N")]), _vm._v("ow that you have some understanding of how to create solid tones with pencil, experiment with different grades of pencils to learn how to create variations in "), _c('em', [_vm._v("value")]), _vm._v(" (the relative lightness or darkness of a color or of black). By shading (adding dark values) and highlighting (adding light values), you produce the value variations that create the illusion of depth and dimension in your drawings, making them appear realistic.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0011-02"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0011-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0012-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0012-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Value Charts")]), _vm._v(" Select a range of pencils from soft to hard. (This chart uses 2B, B, HB, H, and 2H pencils.) Use each pencil to create different techniques, such as linear strokes, crosshatching, and random lines. Use the same amount of pressure with each technique. When your chart is complete, label each different tone with the pencil you used. This chart will help you decide which pencil grades to use for different values and effects.")])])]), _c('a', {
    attrs: {
      "id": "f0012-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0012-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0012-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0012-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0012-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Value Scale")]), _vm._v(" Making your own value scale will help familiarize you with the different variations in value. Select a range of pencils. (This scale was made with 2B, B, HB, H, and 2H pencils.) Start with a 2B pencil to fill an area with horizontal, linear strokes. Then fill in the next areas with a B pencil. Continue in this manner until you create the lightest tone with the 2H pencil.")])])]), _c('a', {
    attrs: {
      "id": "f0012-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0012-02"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0012-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0012-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0012-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Blended Value Scale")]), _vm._v(" Now create a new value scale, this time blending the graphite with a tortillon to make an even, smooth gradation. Start at the far left with your 2B and work your way to the right, blending the graphite evenly to create a smooth texture. When you reach the lightest tones with your 2H, use a very light touch and even pressure to fade the tone off into the white of the paper.")])])]), _c('a', {
    attrs: {
      "id": "f0012-03"
    }
  }), _c('aside', {
    staticClass: "sidebar",
    attrs: {
      "epub:type": "sidebar"
    }
  }, [_c('a', {
    attrs: {
      "id": "f0012-03"
    }
  }, [_c('p', {
    staticClass: "stitle1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13"
    }
  }, [_c('strong', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPLYING")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HADING")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Artists give a three-dimensional look to a two-dimensional drawing by manipulating values. Value refers to the relative lightness or darkness of a color or of black, and it’s the variations in value that help define an object’s form. Because value tells us even more about a form than its outline, figure artists use a variety of techniques to create a full range of shades and highlights, including the ones demonstrated here. The result is more realistic form and dimension in their drawings.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0012-03"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0012-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0013-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0013-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Flat Shading")]), _vm._v(" To shade large areas, create a generalized halftone by using the underhand position.")])])]), _c('a', {
    attrs: {
      "id": "f0013-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0013-01"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0013-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0013-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0013-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Gradation")]), _vm._v(" To produce a gradual shift in value, use the underhand position, varying the pressure from heavy to light.")])])]), _c('a', {
    attrs: {
      "id": "f0013-04"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0013-04"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0013-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0013-07"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-07.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0013-07"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Blending")]), _vm._v(" To produce subtle value transitions and soft edges, smudge with your finger or a blending stump.")])])]), _c('a', {
    attrs: {
      "id": "f0013-07"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0013-07"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0013-07"
    }
  }), _c('a', {
    attrs: {
      "id": "f0013-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0013-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Eraser Strokes")]), _vm._v(" To soften edges and vary the line quality, use a small piece of kneaded eraser. (You can also cut off a sharp piece of vinyl eraser.)")])])]), _c('a', {
    attrs: {
      "id": "f0013-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0013-02"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0013-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0013-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0013-05"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Expressive Lines")]), _vm._v(" To draw fluid lines with a dynamic feel, use the underhand position; then push, pull, twist, and vary pencil pressure as you draw.")])])]), _c('a', {
    attrs: {
      "id": "f0013-05"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0013-05"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0013-05"
    }
  }), _c('a', {
    attrs: {
      "id": "f0013-08"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-08.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0013-08"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Dotting")]), _vm._v(" To create background textures, such as those of a wall or carpet, vary the pressure of your strokes and use your imagination.")])])]), _c('a', {
    attrs: {
      "id": "f0013-08"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0013-08"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0013-08"
    }
  }), _c('a', {
    attrs: {
      "id": "f0013-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0013-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Crosshatching")]), _vm._v(" To deepen shadows and enhance form, use crisscrossing strokes. The more strokes that overlap one another, the darker the area becomes.")])])]), _c('a', {
    attrs: {
      "id": "f0013-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0013-03"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0013-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0013-06"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-06.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0013-06"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Linear Hatching")]), _vm._v(" To create form with shading, make parallel strokes that follow the shape, curve, or direction of the surface. Change the pressure of your strokes to vary the value.")])])]), _c('a', {
    attrs: {
      "id": "f0013-06"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0013-06"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0013-06"
    }
  }), _c('a', {
    attrs: {
      "id": "f0013-09"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-09.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0013-09"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('strong', [_vm._v("Squiggles")]), _vm._v(" For more contrast in your drawings, include loose, circular strokes and squiggles. When used with hatching, these strokes create many interesting textures.")])])]), _c('a', {
    attrs: {
      "id": "f0013-09"
    }
  })]), _c('a', {
    attrs: {
      "id": "f0013-09"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev7"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKING WITH")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HADOW")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("E")]), _vm._v("very shape or form we see is created by the reaction of the object’s surface to light. To create a realistic image, the subject must be lit in a way that brings out its true form. For example, if you light an object from the front, you won’t see the shadows that fall across the form, so it will appear flat. If you light the object from a three-quarter angle, the object will produce shadows; the transition in values will accentuate the object’s dimension.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("There are two main types of shadows: cast shadows and form shadows. "), _c('em', [_vm._v("Cast shadows")]), _vm._v(" are the shadows that the object throws onto other surfaces. "), _c('em', [_vm._v("Form shadows")]), _vm._v(" are the shadows that are on the surface of the object itself—these shadows give an object a sense of depth. Form shadows are dependent on the light source; they get darker as they move away from the light.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A drawing with a sharp contrast between light and shadow (very dark darks and very light lights) is considered a “high-contrast” work, whereas a drawing that uses mostly light and mid-range values is called a “low-contrast” work. Adding more contrast to your drawings will make the subject “pop” forward and look more three-dimensional, but you may want to use less contrast for “softer” subjects, such as a lioness nursing her cubs. Explore the difference between high- and low-contrast drawings by studying the examples below.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0013-09"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0013-09"
    }
  }), _c('a', {
    attrs: {
      "id": "f0014-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0014-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("High Contrast")]), _vm._v(" This egg has a very strong light source directed at it, resulting in a bright highlight area, dark mid-range values, and a very dark cast shadow. The drawing is believable as an egg, but it looks rather hard, as if it were made of stone.")])])]), _c('a', {
    attrs: {
      "id": "f0014-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0014-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0014-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0014-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0014-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Low Contrast")]), _vm._v(" This drawing has a much softer light source, resulting in more mid-range values on the surface of the egg and lighter shadows. Although the shadows are less defined than in the previous drawing, the egg looks more believable as an organic object.")])])]), _c('a', {
    attrs: {
      "id": "f0014-02"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev8"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGINNING WITH")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIC")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("nyone can draw just about anything by simply breaking down the subject into the few basic shapes: circles, rectangles, squares, and triangles. By drawing an outline around the basic shapes of your subject, you’ve drawn its shape. But your subject also has depth and dimension, or "), _c('em', [_vm._v("form")]), _vm._v(". As you see in the drawing on the right, the corresponding forms of the basic shapes are spheres, cylinders, cubes, and cones. For example, a ball and a grapefruit are spheres, a jar and a tree trunk are cylinders, a box and a building are cubes, and a pine tree and a funnel are cones. That’s all there is to the first step of every drawing: sketching the shapes and developing the forms. After that, it’s essentially just connecting and refining the lines and adding details.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0014-02"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0014-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0015-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0015-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Creating Forms")]), _vm._v(" Here are diagrams showing how to draw the forms of the four basic shapes. The ellipses show the backs of the circle, cylinder, and cone, and the cube is drawn by connecting two squares with parallel lines.")])])]), _c('a', {
    attrs: {
      "id": "f0015-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0015-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0015-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0015-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0015-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Combining Shapes")]), _vm._v(" Here is an example of beginning a drawing with basic shapes. Start by drawing each line of action (an imaginary line tracing the path of action through a character), then build up the shapes of the dog and the chick with simple ovals, circles, rectangles, and triangles.")])])]), _c('a', {
    attrs: {
      "id": "f0015-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0015-02"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0015-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0015-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0015-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Building Form")]), _vm._v(" Once you establish the shapes, it is easy to build up the forms with cylinders, spheres, and cones. Notice that the subjects are now beginning to show some depth and dimension.")])])]), _c('a', {
    attrs: {
      "id": "f0015-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0015-03"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0015-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0015-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0015-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Drawing Through")]), _vm._v(" Drawing through means drawing the complete forms, including the lines that will eventually be hidden from sight. Here when the forms were drawn, the back side of the dog and chick were indicated. Even though you can’t see that side in the finished drawing, the subject should appear three-dimensional. To finish the drawing, simply refine the outlines and add a little fluffy texture to the downy chick.")])])]), _c('a', {
    attrs: {
      "id": "f0015-04"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev9"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMPLIFYING WITH")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("hen you’re just starting out, drawing animals from life can be very confusing. Often your first time drawing from life results in something that doesn’t look anything like the animal in front of you. Don’t be discouraged; you might just be drawing your preconceived notion of what the animal "), _c('em', [_vm._v("should")]), _vm._v(" look like instead of what it "), _c('em', [_vm._v("really")]), _vm._v(" looks like. The best way to avoid this is to make a deliberate effort not to draw the animal but, instead, to draw the shapes that compose the animal. By breaking down the animal into simple circles, ovals, squares, or triangles, you not only lessen the confusion, but you also make it easier to get the correct structure and proportions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Below are several animal drawings that are made up of simplified shapes. As you can see, cylinders, circles, and ovals form the basic structure of each drawing. I often use this technique to begin a drawing. When you take your sketchbook out into the field and begin to draw, start with these simple shapes and lines. Work quickly and freely, and keep the drawing simple. Don’t be worried if the animal is moving; just start another drawing on the same or next page. An animal usually will pace and return to its previous position so you can continue where the first or second drawing left off. Fill your page with several different views and angles of the moving animal. Don’t fuss over small details; try to capture the overall form and feeling of the animal. Your aim is to take a quick “snapshot” in pencil.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0015-04"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0015-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0016-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0016-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Lion")])])])]), _c('a', {
    attrs: {
      "id": "f0016-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0016-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0016-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0016-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0016-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Sumatran tiger")])])])]), _c('a', {
    attrs: {
      "id": "f0016-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0016-02"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0016-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0016-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0016-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Australian fur seal")])])])]), _c('a', {
    attrs: {
      "id": "f0016-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0016-03"
    }
  }), _c('div', {
    staticClass: "portvh60"
  }, [_c('a', {
    attrs: {
      "id": "f0016-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0016-04"
    }
  }, [_c('img', {
    staticClass: "vh60",
    attrs: {
      "alt": "Image",
      "src": "images/f0016-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0016-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Squirrel monkey")])])])]), _c('a', {
    attrs: {
      "id": "f0016-04"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0016-04"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0016-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0016-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0016-05"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Black wallaby")])])])]), _c('a', {
    attrs: {
      "id": "f0016-05"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev10"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAWING")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CCURATELY")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("ccuracy is essential to drawing lifelike animals. If you are drawing in a more impressionistic manner, clinical accuracy is not as important—but your drawing must still retain a degree of reality to convince the viewer that your drawing is believable. Below are three different methods you can use to render the profile of a lioness with believable accuracy.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_c('strong', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAWING")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEHAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Freehand drawing is a skill that every artist needs to develop and practice, as it helps you observe and understand the form and structure of your subject. The more you practice, the better you will become. I always start my freehand work by observing and then breaking down the subject into simple shapes and measurement guidelines.")])])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0016-05"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0016-05"
    }
  }), _c('a', {
    attrs: {
      "id": "f0017-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0017-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Starting Simply")]), _vm._v(" This profile can be seen as a combination of triangles, wedges, circles, and lines. I start by drawing two plumb lines (vertical lines), crossing these with two horizontal lines. Within the square formed where the lines intersect, I draw a triangle to represent the eye. Then I use a series of straight lines to mark the angles and positions of the head and features. Now I have a basic structure drawing.")])])]), _c('a', {
    attrs: {
      "id": "f0017-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0017-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0017-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0017-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0017-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Developing the Drawing")]), _vm._v(" I continue drawing with confident strokes, building up the shape as I develop the drawing. As I draw, I constantly refer to my reference photo. I don’t erase all of my structure lines; I build on them using a series of “searching” lines to establish shape, darkening the lines I think are most correct. It doesn’t matter if the drawing gets a bit messy with all your searching lines, as the viewer’s eye will be attracted to the darker, corrected line. This freehand profile took me about 15 minutes to complete.")])])]), _c('a', {
    attrs: {
      "id": "f0017-02"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev11"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UCK")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("B")]), _vm._v("irds are wonderful subjects because they have clean, simple lines and can be rendered with as little or as much detail as you choose. The drawings start with a simple basic shape—an oval or a circle—and then the rest of the bird is built around that shape.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('em', [_vm._v("Collect some photos of different birds for your practice drawings. It’s much easier to work from pictures than to try to get your feathered subject to stay still!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Starting with an HB pencil, make a long, narrow oval for the duck’s body, and mark the top of the head with a straight, angled line. Then draw the curves of the neck, and sketch in the shape of the bill as in step 1. Don’t forget the ground line and angled lines for the feet. Add the eye and a few simple curved lines for the wings and tail in step 2. Then refine the outline, and add only as much detail as you’d like.")])]), _c('div', {
    staticClass: "portvh80"
  }, [_c('a', {
    attrs: {
      "id": "f0017-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0018-01"
    }
  }, [_c('img', {
    staticClass: "vh80",
    attrs: {
      "alt": "Image",
      "src": "images/f0018-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0018-01"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The duck on this page also provides an excellent study in proportion. "), _c('em', [_vm._v("Proportion")]), _vm._v(" is the proper relation of one part to another or to the whole, particularly in terms of size and shape. This duck’s body is twice the length of its head and neck combined, and its bill is roughly as long as its head. Keep these proportions in mind as you block in your drawing.")])]), _c('div', {
    staticClass: "portvh80"
  }, [_c('a', {
    attrs: {
      "id": "f0018-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0018-02"
    }
  }, [_c('img', {
    staticClass: "vh80",
    attrs: {
      "alt": "Image",
      "src": "images/f0018-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0018-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0018-02"
    }
  }), _c('div', {
    staticClass: "portvh80"
  }, [_c('a', {
    attrs: {
      "id": "f0018-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0018-03"
    }
  }, [_c('img', {
    staticClass: "vh80",
    attrs: {
      "alt": "Image",
      "src": "images/f0018-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0018-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Just a few simple lines are all you need to suggest this duck’s form.")])])]), _c('a', {
    attrs: {
      "id": "f0018-03"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev12"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("C")]), _vm._v("ranes are graceful birds with long beaks, long legs, and broad wingspans. The crane‘s elegant lines make it a good subject for either brush and ink or a simple pencil rendering. Whichever medium you choose, the first step in your drawing is to sketch an oval for the bird’s body with an HB pencil. In step 2, block in the outline of the wings, and establish the general placement of the legs and head. Develop the outline further and block in some of the wing feathers.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0018-03"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0018-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0019-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0019-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("The drawing is built around a basic oval shape.")])])]), _c('a', {
    attrs: {
      "id": "f0019-01"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0019-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0019-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0019-02"
    }
  }), _c('div', {
    staticClass: "portvh80"
  }, [_c('a', {
    attrs: {
      "id": "f0019-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0019-03"
    }
  }, [_c('img', {
    staticClass: "vh80",
    attrs: {
      "alt": "Image",
      "src": "images/f0019-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0019-03"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("At this stage, you can either finish the crane with a soft lead pencil or try your hand at using brush and india ink. Brush and ink allows you to make interesting variations in the width and intensity of your lines. Use a soft-haired #3 brush for thin lines and a #6 for thick lines. Experiment with different amounts of ink and water to see what effects you can achieve.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('em', [_vm._v("Don’t be afraid to try brush and ink. It takes a little practice to master, but you can do it!")])])]), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0019-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0019-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0019-04"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0019-04"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0019-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0019-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0019-05"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Here is a close-up of the crane’s head. Note the detail on the beak and on the head.")])])])]), _c('a', {
    attrs: {
      "id": "f0019-05"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev13"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILDLIFE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXTURES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("N")]), _vm._v("ature provides some of the most exquisite and interesting textures. Drawing wildlife is especially helpful because each animal comprises a number of different textural elements. Think about a bird with its sleek feathers, scaly feet, smooth beak, and glistening eyes. What more could an artist ask for?")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In my backyard, there is a wealth of textures just waiting to challenge me, from a delicate butterfly to a scruffy groundhog. All of the textures on this page can be found right outside my door. What is waiting outside your door?")])]), _c('div', {
    staticClass: "groupa"
  }, [_c('a', {
    attrs: {
      "id": "f0019-05"
    }
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EATHERS")])])])]), _c('div', {
    staticClass: "portvh60"
  }, [_c('a', {
    attrs: {
      "id": "f0019-05"
    }
  }), _c('a', {
    attrs: {
      "id": "f0020-01"
    }
  }, [_c('img', {
    staticClass: "vh60",
    attrs: {
      "alt": "Image",
      "src": "images/f0020-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0020-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 1")]), _vm._v(" To capture the wispy, fragile texture of a peacock’s feather, I start by drawing thin lines that stem from a vertical centerline. Then I draw a circle within an oval for the “eye”—I draw the curved lines that surround the “eye” so that they follow the ovular form.")])])]), _c('a', {
    attrs: {
      "id": "f0020-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0020-01"
    }
  }), _c('div', {
    staticClass: "portvh60"
  }, [_c('a', {
    attrs: {
      "id": "f0020-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0020-02"
    }
  }, [_c('img', {
    staticClass: "vh60",
    attrs: {
      "alt": "Image",
      "src": "images/f0020-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0020-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 2")]), _vm._v(" I darken the center of the “eye” to emphasize the peacock feather’s distinctive pattern. I keep the area around the center very light to indicate the change in color and the delicate feather texture.")])])]), _c('a', {
    attrs: {
      "id": "f0020-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0020-02"
    }
  }), _c('div', {
    staticClass: "portvh60"
  }, [_c('a', {
    attrs: {
      "id": "f0020-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0020-03"
    }
  }, [_c('img', {
    staticClass: "vh60",
    attrs: {
      "alt": "Image",
      "src": "images/f0020-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0020-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 3")]), _vm._v(" After darkening all my lines, I use a kneaded eraser to lift out a small curve along the edge of the dark center. (See “Lifting Out” below for more information.)")])])]), _c('a', {
    attrs: {
      "id": "f0020-03"
    }
  }), _c('aside', {
    staticClass: "sidebara",
    attrs: {
      "epub:type": "sidebar"
    }
  }, [_c('a', {
    attrs: {
      "id": "f0020-03"
    }
  }, [_c('p', {
    staticClass: "stitle1"
  }, [_c('strong', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFTING")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT FOR")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EATHERS")])])])]), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0020-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0020-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0020-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0020-04"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here I use an eraser to lift out the white edges of the feathers. I go back in and reinforce the edges with pencil to show the defined edges of the feathers. It often is difficult to control the shape of the edges of the lifted area, so the delicacy of the edges can be lost. I use short lines that follow the direction of the feathers to create additional texture. Then I blend the background with an eraser to help make the feathers stand out.")])])]), _c('a', {
    attrs: {
      "id": "f0020-04"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0020-04"
    }
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21"
    }
  }, [_c('strong', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CALES")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KIN")])])])])]), _c('div', {
    staticClass: "land100i"
  }, [_c('a', {
    attrs: {
      "id": "f0020-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0021-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0021-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Alligator")]), _vm._v(" I use a soft, broad pencil with plate-finish paper, as I don’t want the effects of rough paper to interfere with the leathery, bumpy texture of the alligator’s skin. Pay attention to the direction of the light source when dealing with textures—alligator skin is made up of many small ridges, and each ridge must be lit properly for the drawing to appear realistic.")])])]), _c('a', {
    attrs: {
      "id": "f0021-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0021-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0021-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0021-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0021-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Fish")]), _vm._v(" First I outline the scales, paying careful attention to the details. Then I add shading at the base of the scales where they overlap to show the distinctive flaky texture. Note that every scale has been given a highlight—this helps capture the fish’s shimmery nature.")])])]), _c('a', {
    attrs: {
      "id": "f0021-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0021-03"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0021-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0021-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0021-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Butterfly")]), _vm._v(" First I carefully outline the drawing with a sharp HB pencil. I lightly draw the very thin veins, using long strokes. I go back in and put down another layer of tone, this time also covering the lighter areas of the wing. Next I use a 2B pencil to deepen the veins, gradually increasing the pressure on my pencil and using long strokes that follow the shape of the wing. I switch back to the HB and use long strokes to deepen the light tones of the wing, allowing some strokes to be darker to create a slight variation in the soft tones within the lighter area.")])])]), _c('a', {
    attrs: {
      "id": "f0021-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0021-02"
    }
  }), _c('div', {
    staticClass: "portvh80"
  }, [_c('a', {
    attrs: {
      "id": "f0021-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0021-04"
    }
  }, [_c('img', {
    staticClass: "vh80",
    attrs: {
      "alt": "Image",
      "src": "images/f0021-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0021-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Frog")]), _vm._v(" Frog skin is usually moist, so using a smudging technique helps create a nice effect. I use darker tones to create the raised bumps and lift out some graphite to add highlights to the slimy surface to give a wet look to the entire skin.")])])]), _c('a', {
    attrs: {
      "id": "f0021-04"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev14"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIMAL")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXTURES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("O")]), _vm._v("nce you have a basic understanding of an animal’s skeletal structure, you must “clothe” it in either skin or hair. There is a vast range of textures you can create for skin and hair, and each requires a slightly different technique to achieve a realistic effect. Here I break down the process of drawing six different textures into steps so you can see how they are created. I use these techniques throughout the book, so you may want to refer to these pages when following the step-by-step projects.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0021-04"
    }
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HORT")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")])])])]), _c('div', {
    staticClass: "land100i"
  }, [_c('a', {
    attrs: {
      "id": "f0021-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0022-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0022-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 1")]), _vm._v(" I create a light undercoat with a series of swift, short pencil strokes and a very sharp 2H .5 mm mechanical pencil. (Every pencil must be very sharp to achieve this effect.) I draw the strokes in the direction of the fur growth and avoid forming obvious patterns.")])])]), _c('a', {
    attrs: {
      "id": "f0022-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0022-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0022-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0022-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0022-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 2")]), _vm._v(" Now I use a sharp HB lead to create the second layer, using the same technique as in step 1. I don’t fill in the entire area; instead I leave some of the paper showing through the lines for highlights.")])])]), _c('a', {
    attrs: {
      "id": "f0022-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0022-02"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0022-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0022-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0022-03"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "f0022-03"
    }
  }, [_c('strong', [_vm._v("Step 3")]), _vm._v(" I switch to a 2B pencil to work over the area again with the same short, swift strokes. This deepens the tone of the fur and creates a realistic texture. The darker 2B helps make the untouched areas “read” as lighter, individual hairs. This method is used for the kangaroo’s fur ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#page_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("shown here")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "groupa"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HORT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTERNED")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")])])]), _vm._v(" "), _c('div', {
    staticClass: "land100i"
  }, [_c('a', {
    attrs: {
      "id": "f0022-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0022-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 1")]), _vm._v(" I use a blunt F pencil to fill in spots with very light, solid tone. Then I switch to a 2H pencil to work in a similar manner as in step 1 of “Short Fur” but build up dark areas by placing dark 2H strokes close together.")])])]), _c('a', {
    attrs: {
      "id": "f0022-04"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0022-04"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0022-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0022-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0022-05"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 2")]), _vm._v(" Now I switch to an HB pencil to make short strokes following the direction of fur growth. In the spotted areas, I keep the strokes close together; in the lighter areas, I keep the strokes farther apart. I leave some paper showing through for highlights.")])])]), _c('a', {
    attrs: {
      "id": "f0022-05"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0022-05"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0022-05"
    }
  }), _c('a', {
    attrs: {
      "id": "f0022-06"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-06.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0022-06"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 3")]), _vm._v(" I intensify the dark spots with a sharp 2B pencil and many closely placed strokes, varying the pressure on each stroke. I build up the tone a bit more in the lighter areas with a sharp HB.")])])]), _c('a', {
    attrs: {
      "id": "f0022-06"
    }
  }), _c('div', {
    staticClass: "groupa"
  }, [_c('a', {
    attrs: {
      "id": "f0022-06"
    }
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONG")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIR")])])])]), _c('div', {
    staticClass: "land100i"
  }, [_c('a', {
    attrs: {
      "id": "f0022-06"
    }
  }), _c('a', {
    attrs: {
      "id": "f0022-07"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-07.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0022-07"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 1")]), _vm._v(" I use a very sharp HB .5 mm mechanical pencil to draw a series of long, curved strokes to make a “clump” of 20 to 30 lines. I draw all the lines in a clump in the same direction and at about the same length. Each clump varies in direction and length and often overlaps another clump.")])])]), _c('a', {
    attrs: {
      "id": "f0022-07"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0022-07"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0022-07"
    }
  }), _c('a', {
    attrs: {
      "id": "f0022-08"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-08.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0022-08"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 2")]), _vm._v(" As with the short fur, I use a sharp HB lead for the second layer, making my strokes more random than with the short fur. Again I leave areas of white showing through the strokes.")])])]), _c('a', {
    attrs: {
      "id": "f0022-08"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0022-08"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0022-08"
    }
  }), _c('a', {
    attrs: {
      "id": "f0022-09"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-09.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0022-09"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "f0022-09"
    }
  }, [_c('strong', [_vm._v("Step 3")]), _vm._v(" I switch to a 2B pencil to build up dark areas using long strokes. I create the darkest areas near the lightest lines and in areas where I want the deepest shadows. This contrast forms natural “hairs” and highlights. This method is used for the lion’s mane ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("shown here")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "groupa"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23"
    }
  }, [_c('strong', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HITE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIR")])])])]), _vm._v(" "), _c('div', {
    staticClass: "land100i"
  }, [_c('a', {
    attrs: {
      "id": "f0023-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0023-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 1")]), _vm._v(" Many artists are intimidated by drawing white hair, but I love drawing it! The white of the paper does most of the work for you. You really only need to draw the shadows and the negative areas. I create the undercoat with a sharp 2H lead, but I lay down strokes only in the cast shadow areas. I keep my strokes very, very light.")])])]), _c('a', {
    attrs: {
      "id": "f0023-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0023-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0023-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0023-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0023-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 2")]), _vm._v(" With a sharp HB lead, I carefully create the shadows cast by the hairs, following the direction of hair growth. I don’t draw too many lines, as I don’t want to fill in all the white areas.")])])]), _c('a', {
    attrs: {
      "id": "f0023-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0023-02"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0023-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0023-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0023-03"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "f0023-03"
    }
  }, [_c('strong', [_vm._v("Step 3")]), _vm._v(" I switch to a sharp 2B to carefully create the darkest shadow areas. These dark values sharply contrast with the white of the paper, creating the illusion of white hair. Now I use the tip of the 2H to add some light strokes here and there to give the hair a little more definition. This technique is used in the lightest areas of the koala ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#page_186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("shown here")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "groupa"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUGH")]), _vm._v(", W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINKLED")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KIN")])])]), _vm._v(" "), _c('div', {
    staticClass: "land100i"
  }, [_c('a', {
    attrs: {
      "id": "f0023-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0023-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 1")]), _vm._v(" With a blunt F pencil, I lay down a light, even tone. Then I use a clean tortillon to blend and soften the tone, eliminating much of the “grain” of the paper. I try to keep some areas lighter and some darker so I don’t create a flat tone.")])])]), _c('a', {
    attrs: {
      "id": "f0023-04"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0023-04"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0023-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0023-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0023-05"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 2")]), _vm._v(" To add wrinkles on top of the smooth tone, I use what I call a “scrumbling” technique. With a sharp 2H lead, I cover certain areas with a squiggly line that I make without lifting my pencil. This line sort of wanders about, creating the illusion of a bumpy texture. Then I switch to an HB to draw slightly darker horizontal lines over the scrumble lines. These lines of varying lengths represent the wrinkles.")])])]), _c('a', {
    attrs: {
      "id": "f0023-05"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0023-05"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0023-05"
    }
  }), _c('a', {
    attrs: {
      "id": "f0023-06"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-06.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0023-06"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 3")]), _vm._v(" Now I alternate between an HB and a 2B, adding more lines and scrumble lines over the first layer of tone. This loose technique works well for elephant, rhinoceros, and some reptile hides. It also can be used to create leathery effects for noses and footpads if the undercoat is created with a darker B pencil.")])])]), _c('a', {
    attrs: {
      "id": "f0023-06"
    }
  }), _c('div', {
    staticClass: "groupa"
  }, [_c('a', {
    attrs: {
      "id": "f0023-06"
    }
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPTILE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KIN")])])])]), _c('div', {
    staticClass: "land100i"
  }, [_c('a', {
    attrs: {
      "id": "f0023-06"
    }
  }), _c('a', {
    attrs: {
      "id": "f0023-07"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-07.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0023-07"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 1")]), _vm._v(" With a 2H pencil, I lightly draw a series of lines in one direction and another series of lines in the opposite direction to form a diamond pattern. I use a blunt F pencil to fill in each diamond with a series of lines placed close together. I leave a slight white outline and a highlight in the upper left corner of each diamond.")])])]), _c('a', {
    attrs: {
      "id": "f0023-07"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0023-07"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0023-07"
    }
  }), _c('a', {
    attrs: {
      "id": "f0023-08"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-08.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0023-08"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 2")]), _vm._v(" Switching back to the 2H, I stroke in the opposite direction on top of the layer of F strokes. This creates a blending effect without smudging the graphite with a tortillon. Now I add circular strokes with an HB in each diamond, concentrating on the lower right of each shape. I also use the HB to fill in the white outline around each diamond, creating a shadow between each shape.")])])]), _c('a', {
    attrs: {
      "id": "f0023-08"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0023-08"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0023-08"
    }
  }), _c('a', {
    attrs: {
      "id": "f0023-09"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-09.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0023-09"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Step 3")]), _vm._v(" Finally, I use a 2B to create the darkest shadow areas in the lower right of each diamond. Then I use an HB to add circular strokes over the previous layer, evening out the tone.")])])]), _c('a', {
    attrs: {
      "id": "f0023-09"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev15"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("B")]), _vm._v("ears have large heads and bulky bodies; their hindquarters are massive, and they have short, powerful legs. They also have long, sharp claws made for digging. Even though they move slowly while walking, they can run very fast.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Remember to study each part of the animal’s anatomy before starting to draw. Try to capture the bear’s personality as you draw, paying attention to how each line affects the whole drawing.")])]), _c('div', {
    staticClass: "portvh80"
  }, [_c('a', {
    attrs: {
      "id": "f0023-09"
    }
  }), _c('a', {
    attrs: {
      "id": "f0024-01"
    }
  }, [_c('img', {
    staticClass: "vh80",
    attrs: {
      "alt": "Image",
      "src": "images/f0024-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0024-01"
    }
  }), _c('div', {
    staticClass: "portvh80"
  }, [_c('a', {
    attrs: {
      "id": "f0024-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0024-02"
    }
  }, [_c('img', {
    staticClass: "vh80",
    attrs: {
      "alt": "Image",
      "src": "images/f0024-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0024-02"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The block-in steps shown above are good examples of how to begin. Once you are satisfied with the bear’s position, add details and shading.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Practice making strokes like the ones shown below. They can be used to shade your animal drawings, creating the illusion of fur.")])]), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0024-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0024-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0024-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0024-03"
    }
  }), _c('aside', {
    staticClass: "sidebar",
    attrs: {
      "epub:type": "sidebar"
    }
  }, [_c('a', {
    attrs: {
      "id": "f0024-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0024-03"
    }
  }, [_c('p', {
    staticClass: "stitle1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25"
    }
  }, [_c('strong', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATING")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIMAL")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXTURES")])])])])]), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0024-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Smooth Scales")]), _vm._v(" To depict smooth scales, first draw ovals of various sizes; then shade between them. Because scales overlap, be sure to partially cover each scale with the next layer.")])])]), _c('a', {
    attrs: {
      "id": "f0025-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0025-01"
    }
  }), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0025-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Rough Scales")]), _vm._v(" For rough scales, create irregular shapes that follow a slightly curved alignment. Shade darkly between the shapes; then shade over them with light, parallel strokes.")])])]), _c('a', {
    attrs: {
      "id": "f0025-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0025-02"
    }
  }), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0025-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Fine Feathers")]), _vm._v(" For light, downy feathers, apply thin, parallel lines along the feather stems, forming a series of V shapes. Avoid crisp outlines, which would take away from the softness.")])])]), _c('a', {
    attrs: {
      "id": "f0025-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0025-03"
    }
  }), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0025-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Heavy Feathers")]), _vm._v(" To create thicker, more defined feathers, use heavier parallel strokes and blend with a tortillon. Apply the most graphite to the shadowed areas between the feathers.")])])]), _c('a', {
    attrs: {
      "id": "f0025-04"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0025-04"
    }
  }), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0025-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-05"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Hide")]), _vm._v(" To create a shiny, short-haired hide, apply short, straight strokes with the broad side of the pencil. For subtle wrinkles, add a few horizontal strips that are lighter in value.")])])]), _c('a', {
    attrs: {
      "id": "f0025-05"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0025-05"
    }
  }), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0025-05"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-06"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-06.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-06"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Wavy Hair")]), _vm._v(" For layers of soft curls, stroke in S-shaped lines that end in tighter curves. Leave the highlights free of graphite and stroke with more pressure as you move to the shadows.")])])]), _c('a', {
    attrs: {
      "id": "f0025-06"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0025-06"
    }
  }), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0025-06"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-07"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-07.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-07"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Rough Coat")]), _vm._v(" For a subtle striped pattern, apply short strokes in the direction of fur growth. Then apply darker strokes in irregular horizontal bands. Pull out highlights with an eraser.")])])]), _c('a', {
    attrs: {
      "id": "f0025-07"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0025-07"
    }
  }), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0025-07"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-08"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-08.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-08"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Smooth Coat")]), _vm._v(" For a smooth, silky coat, use sweeping parallel pencil strokes, leaving the highlighted areas free of graphite. Alternate between the pencil tip and the broad side for variation.")])])]), _c('a', {
    attrs: {
      "id": "f0025-08"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0025-08"
    }
  }), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0025-08"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-09"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-09.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-09"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Curly Hair")]), _vm._v(" Curly, woolly coats can be drawn with overlapping circular strokes of varying values. For realism, draw curls of differing shapes and sizes and blend for softness.")])])]), _c('a', {
    attrs: {
      "id": "f0025-09"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0025-09"
    }
  }), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0025-09"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-10.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-10"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Long Hair")]), _vm._v(" To render long hair – whether it’s the whole coat or just a mane or tail – use longer, sweeping strokes that curve slightly, and taper the hairs to a point at the ends.")])])]), _c('a', {
    attrs: {
      "id": "f0025-10"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0025-10"
    }
  }), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0025-10"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-11.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-11"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Whiskers")]), _vm._v(" To suggest whiskers, first apply rows of dots on the animal’s cheek. Fill in the fur as you have elsewhere; then, with the tip of a kneaded eraser, lift out thin, curving lines.")])])]), _c('a', {
    attrs: {
      "id": "f0025-11"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0025-11"
    }
  }), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0025-11"
    }
  }), _c('a', {
    attrs: {
      "id": "f0025-12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-12.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0025-12"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('strong', [_vm._v("Nose")]), _vm._v(" Most animal noses have a bumpy texture that can be achieved with a very light scale pattern. Add a shadow beneath the nose; then pull out highlights with a kneaded eraser.")])])]), _c('a', {
    attrs: {
      "id": "f0025-12"
    }
  })]), _c('a', {
    attrs: {
      "id": "f0025-12"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev16"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URRO")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("o draw this little fellow, visualize the shape of his head without the soft, fluffy fur. Once again, lay down your block-in lines in the numbered order shown in step A. Continue through step C until you’ve developed basic head features. Create the fur with a wash technique, using a #3 round brush and a wash of water and india ink (or black watercolor paint).")])]), _c('div', {
    staticClass: "portvh60"
  }, [_c('a', {
    attrs: {
      "id": "f0025-12"
    }
  }), _c('a', {
    attrs: {
      "id": "f0026-01"
    }
  }, [_c('img', {
    staticClass: "vh60",
    attrs: {
      "alt": "Image",
      "src": "images/f0026-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0026-01"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0026-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0026-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0026-02"
    }
  }), _c('div', {
    staticClass: "portvh70"
  }, [_c('a', {
    attrs: {
      "id": "f0026-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0026-03"
    }
  }, [_c('img', {
    staticClass: "vh70",
    attrs: {
      "alt": "Image",
      "src": "images/f0026-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0026-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0026-03"
    }
  }), _c('div', {
    staticClass: "portvh60"
  }, [_c('a', {
    attrs: {
      "id": "f0026-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0026-04"
    }
  }, [_c('img', {
    staticClass: "vh60",
    attrs: {
      "alt": "Image",
      "src": "images/f0026-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0026-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("#3 Round Brush")])])]), _c('a', {
    attrs: {
      "id": "f0026-04"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0026-04"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0026-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0026-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0026-05"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("#6 Round Brush")])])]), _c('a', {
    attrs: {
      "id": "f0026-05"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Wet the paper with water before applying the ink or paint. You should practice this on a separate piece of paper to test the effect of the wash. Once you’ve successfully achieved the effect of fur, you can begin working on the actual drawing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("After applying the wash, lift your paper and tip it in various angles to let the color bleed in different directions. Doing this gives three-dimensional form to the burro’s head.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev17"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUIRREL")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("N")]), _vm._v("ote how this drawing differs from the previous one in terms of shading and texture. Although this little squirrel isn’t difficult to draw, make certain each block-in step is correct before moving to the next one. For example, because the squirrel doesn’t face directly forward, the eye that is farther away must be correctly positioned to make it look realistic.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0026-05"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0026-05"
    }
  }), _c('a', {
    attrs: {
      "id": "f0027-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0027-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0027-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("HB Pencil")])])]), _c('a', {
    attrs: {
      "id": "f0027-01"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0027-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0027-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0027-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0027-02"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0027-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0027-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0027-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0027-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0027-03"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0027-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0027-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0027-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0027-04"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_vm._v("#3 Round Watercolor Brush")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Change brush pressure to vary line thickness.")])])])]), _c('a', {
    attrs: {
      "id": "f0027-04"
    }
  }, [_c('p', {
    staticClass: "note"
  }, [_c('em', [_vm._v("Your drawings may not always come out as well as you’d like. In fact, it just happened to me with this squirrel! So what am I going to do? Draw it over and over until I’m satisfied. That’s what you should do too!")])])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0027-04"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0027-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0027-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0027-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0027-05"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("3B or 6B Pencil")])])]), _c('a', {
    attrs: {
      "id": "f0027-05"
    }
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev18"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPERIMENTING WITH")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFFERENT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("D")]), _vm._v("rawing is a creative process. As an artist, I am constantly looking for new ways to stimulate my imagination, and I’m always interested in exploring different methods of working. One of the best ways to do this is to experiment with different media. Here I’ve branched out and drawn with pen and ink, charcoal sticks and pencils, and Conté crayons to show just a glimpse of the possibilities. Be adventurous, and try some new materials on your own.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_c('strong', [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPLORING")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIMAL")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXTURES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I love drawing animals, partly because I’m so fond of them and partly because they’re such beautiful creatures. They range from small and delicate to large and powerful, with an array of different colors, textures, and patterns. It’s great fun to try to show the differences between the shaggy coat of the coyote pup and the long mane of the lion, or the thick, black-and-white fur of the panda and the patterned stripes of the tiger or zebra. Try it yourself!")])])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0027-05"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0027-05"
    }
  }), _c('a', {
    attrs: {
      "id": "f0028-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0028-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0028-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Conté Crayon")]), _vm._v(" To show the rough fur of this coyote pup, I decided to use Conté crayon. I used loose, sketchy strokes for the longer hair, and blended my strokes around the eyes and face. To blend, you can smudge with your fingers or with a soft brush and water; here I blended by layering a white Conté over the black.")])])]), _c('a', {
    attrs: {
      "id": "f0028-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0028-01"
    }
  }), _c('div', {
    staticClass: "portvh80"
  }, [_c('a', {
    attrs: {
      "id": "f0028-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0028-02"
    }
  }, [_c('img', {
    staticClass: "vh80",
    attrs: {
      "alt": "Image",
      "src": "images/f0028-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0028-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Ink Wash")]), _vm._v(" This drawing was done with a wash of india ink and water. By adding more or less water to the ink, you can make any value you want. For the larger masses of shading, I loaded the brush with diluted ink and applied a wash with the side of the brush. Then I used a small round, fine-pointed watercolor brush and drew lines with a stronger ink solution for the details.")])])]), _c('a', {
    attrs: {
      "id": "f0028-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0028-02"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0028-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0028-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0028-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0028-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Colored Pencil")]), _vm._v(" I used a black wax pencil for this portrait of a tiger. I was able to create the soft, dark areas of hair using the side of the pencil and holding it in the underhand position. Paper blending stumps don’t blend wax pencil strokes well, so I used one only for the very subtly blended areas, such as the eyes.")])])]), _c('a', {
    attrs: {
      "id": "f0028-03"
    }
  }, [_c('aside', {
    staticClass: "sidebox",
    attrs: {
      "epub:type": "sidebar"
    }
  }, [_c('p', {
    staticClass: "tiptitle"
  }, [_c('strong', [_vm._v("Artist’s Tip")])]), _vm._v(" "), _c('p', {
    staticClass: "tipp"
  }, [_c('em', [_vm._v("Travel, be curious about your surroundings, and accumulate meaningful memories. Your visual imagery will be the richer for it.")])])])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0028-03"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0028-03"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29"
    }
  })]), _c('a', {
    attrs: {
      "id": "f0029-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0029-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Subtle Blends")]), _vm._v(" For this portrait of a regal male lion, I chose charcoal pencil. That enabled me to duplicate the different textures of the hair on the face and on the mane. Then I used white Conté crayon to blend around his cheeks, making the gray tones.")])])]), _c('a', {
    attrs: {
      "id": "f0029-01"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0029-01"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0029-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0029-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0029-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Pen and Ink")]), _vm._v(" This zebra was rendered with a drawing pen with a nonflexible point, which produces the same line width with each stroke. By using very quick, hatching strokes, I was able to achieve some variation of line and shading, although not as much variation as with a ballpoint pen. This tool was well suited for the fine hair and intricate pattern of this striped zebra.")])])]), _c('a', {
    attrs: {
      "id": "f0029-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0029-02"
    }
  }), _c('div', {
    staticClass: "land100"
  }, [_c('a', {
    attrs: {
      "id": "f0029-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0029-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0029-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Ballpoint Pen")]), _vm._v(" For this lioness, I chose a ballpoint pen with a medium point. I made thicker lines by pressing harder on the point, and I made fine lines and detailed shading strokes by holding the pen lightly at its end. Notice the variations in line width and character I was able to produce, as compared to the ink drawing of the zebra. When drawing with ballpoint pen, place a sheet of paper between your hand and the drawing to prevent smudging.")])])]), _c('a', {
    attrs: {
      "id": "f0029-03"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_c('strong', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCLUDING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOUGHTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Choose subjects to draw that you really like, because then you’ll be inspired to spend the time and energy necessary to make your drawings great. Although there is no substitute for practice—and more practice—if you connect with your subject, it will show in your art. Let your interests, hobbies, and personal passions encourage and guide your artistic talent. Best of luck to you—and have fun drawing!")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01lev19"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARROT")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("his bold parrot is rendered in a very different, high-contrast style, which corresponds to the bird’s loud plumage and brazen personality. Its large, hooked beak is a prominent feature, and it will be a focal point in your drawing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Start with a circle in step 1, and then draw perpendicular guidelines to divide it into quarters. This will help you place the eye and beak correctly.")])]), _c('div', {
    staticClass: "land75"
  }, [_c('a', {
    attrs: {
      "id": "f0029-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0030-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0030-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0030-01"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In step 2, extend the line of the circle to the right for the angle of the neck and the back of the head; add curves for the wing and the chest in step 3. Block in the lines of the beak and the mass of the top plumage before you begin shading. Use a soft pencil, or try ink for a more dramatic effect.")])]), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0030-01"
    }
  }), _c('a', {
    attrs: {
      "id": "f0030-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0030-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0030-02"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0030-02"
    }
  }), _c('div', {
    staticClass: "portvh60"
  }, [_c('a', {
    attrs: {
      "id": "f0030-02"
    }
  }), _c('a', {
    attrs: {
      "id": "f0030-03"
    }
  }, [_c('img', {
    staticClass: "vh60",
    attrs: {
      "alt": "Image",
      "src": "images/f0030-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0030-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Always include some part of the body in a head drawing, so the head does not appear to be “floating” on the page.")])])]), _c('a', {
    attrs: {
      "id": "f0030-03"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0030-03"
    }
  }), _c('div', {
    staticClass: "land85"
  }, [_c('a', {
    attrs: {
      "id": "f0030-03"
    }
  }), _c('a', {
    attrs: {
      "id": "f0030-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0030-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0030-04"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("You can even leave the drawing white with thick outlines and make the background solid black. Be creative!")])])]), _c('a', {
    attrs: {
      "id": "f0030-04"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "f0030-04"
    }
  }), _c('div', {
    staticClass: "portvh80"
  }, [_c('a', {
    attrs: {
      "id": "f0030-04"
    }
  }), _c('a', {
    attrs: {
      "id": "f0030-05"
    }
  }, [_c('img', {
    staticClass: "vh80",
    attrs: {
      "alt": "Image",
      "src": "images/f0030-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0030-05"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Try experimenting with different areas of black and white. Make the beak solid black with a stark white highlight, or outline the highlight within a solid white beak.")])])]), _c('a', {
    attrs: {
      "id": "f0030-05"
    }
  })]), _c('a', {
    attrs: {
      "id": "f0030-05"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 63
// module chunks = 0